import { render, staticRenderFns } from "./Face2Pay.vue?vue&type=template&id=5861bc74&scoped=true&"
import script from "./Face2Pay.vue?vue&type=script&lang=js&"
export * from "./Face2Pay.vue?vue&type=script&lang=js&"
import style0 from "./Face2Pay.vue?vue&type=style&index=0&id=5861bc74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861bc74",
  null
  
)

export default component.exports